import axios from "axios";

let API_BASE_URL = process.env.API_BASE_URL || "https://www.parknfly.lt:3443";
// let API_BASE_URL = process.env.API_BASE_URL || "https://localhost:3001";

export const checkAvailability = async (startDate: Date, endDate: Date) => {
  const response = await axios.post(`${API_BASE_URL}/check-availability`, {
    startDate,
    endDate,
  });
  return response.data;
};
